module.exports = __webpack_public_path__ + "img/cent_cover.d26549ca.png";